import { api } from '@/helpers/api'
import { action, makeObservable, observable } from 'mobx'

class UserService {
  @observable userData: ServerData.UserData | null = null

  constructor() {
    makeObservable(this)
  }

  public init() {
    // this.getUserInfo()
    api.user.refreshUserInfo().catch((e) => {
      console.log(e)
    })
  }

  @action
  public getUserInfo() {
    api.user.getUserInfo().then((res) => {
      if (res.success) {
        this.userData = res.data
      }
    })
  }

  @action
  public bindPhone(data: PostData.UserInfoModel) {
    api.user.saveUserInfo(data).then((res) => {
      if (res.success) {
        this.getUserInfo()
      }
    })
  }
}

export const userService = new UserService()
